import {get} from "./framework/paDom";
import {Main, Modal} from "./Main";

export const Events = {
    init() {
        this.binds();
    },
    binds() {
        get('.category').click(Events.categoryClick);
        get('.pa-decade').click(Events.decadeClick);
        get('.modal-hide').click(Main.hideModal);
        get('#control-element').delegate('click', '#image-button', this.modalImageClick);
        get('#control-element').delegate('click', '#chart-button', this.modalChartClick);
        get('.skip-intro').click(Events.hideIntroClick);
        get('#pa-engine-dom-wrapper').delegate('click', '#app-home', this.homeIconClick);
    },
    categoryClick(){
        let dataId = this.getAttribute('data-id');
        Main.selectCategory(dataId);
    },
    decadeClick(e){
        let targetElement = e.target.parentElement.parentElement,
            decadeId = targetElement.getAttribute('data-decade-id');
        Main.selectDecade(decadeId);
    },
    modalImageClick(){
        Main.modalSwitch(true);
    },
    modalChartClick(){
        Main.modalSwitch(false);
    },
    hideIntroClick(){
      Main.hideIntro();
    },
    homeIconClick(){
        Main.showIntro();
    }
};


// WEBPACK FOOTER //
// ./src/js/Events.js